import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";

export default function NotFound() {
  return (
    <main className="flex min-h-[80vh] flex-col items-center justify-center px-6 pt-24 text-center" data-testid="not-found-page">
      <Seo title="Page Not Found" description="The page you are looking for does not exist." path="/404" noindex />
      <p className="font-display text-8xl font-extrabold tracking-tighter text-navy">404</p>
      <h1 className="mt-4 font-display text-2xl font-bold tracking-tight">This page took a trade-in.</h1>
      <p className="mt-3 max-w-md text-[#4A4A4A]">
        The page you are looking for does not exist. Head back home or browse the Buyback Guides.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-4">
        <Link to="/" data-testid="notfound-home-btn"
          className="rounded-full bg-navy px-8 py-3.5 font-display text-sm font-bold uppercase tracking-[0.12em] text-white transition-colors hover:bg-brand">
          Back Home
        </Link>
        <Link to="/guides" data-testid="notfound-guides-btn"
          className="rounded-full border border-black/15 px-8 py-3.5 font-display text-sm font-bold uppercase tracking-[0.12em] text-navy transition-colors hover:bg-navy hover:text-white">
          Buyback Guides
        </Link>
      </div>
    </main>
  );
}
